import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APIService } from '../api/api.service'
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private apiService: APIService) { }


    public getVehicleDetails(payload): any 
    { 
      return this.apiService.getVehicleDetails(payload).pipe(map((response: any) => {
  
          return response;
        }),
        catchError((err) => { return throwError(() => err);  })
      );
    }

    public addVehicle(payload): any 
    { 
      return this.apiService.addVehicle(payload).pipe(map((response: any) => {
  
          return response;
        }),
        catchError((err) => { return throwError(() => err);  })
      );
    }

    public updateVehicle(payload): any 
    { 
      return this.apiService.updateVehicle(payload).pipe(map((response: any) => {
  
          return response;
        }),
        catchError((err) => { return throwError(() => err);  })
      );
    }

    public deleteVehicle(payload): any 
    { 
      return this.apiService.deleteVehicle(payload).pipe(map((response: any) => {
  
          return response;
        }),
        catchError((err) => { return throwError(() => err);  })
      );
    }

    public assignEngineerToVehicle(payload): any 
    { 
      return this.apiService.assignEngineerToVehicle(payload).pipe(map((response: any) => {
  
          return response;
        }),
        catchError((err) => { return throwError(() => err);  })
      );
    }

    public removeEngineerFromVehicle(payload): any 
    { 
      return this.apiService.removeEngineerFromVehicle(payload).pipe(map((response: any) => {
  
          return response;
        }),
        catchError((err) => { return throwError(() => err);  })
      );
    }


  public submitNewVehicleReport(data): any 
  {
    return this.apiService.submitNewVehicleReport(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err); })
    );
  }

  public addVehicleHistoryLog(payload): any 
  { 
    return this.apiService.addVehicleHistoryLog(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public deleteVehicleReport(payload): any 
  { 
    return this.apiService.deleteVehicleReport(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }
}
